// import React, { useState, useEffect } from "react";
// import { Modal, Box, Typography } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import { Link, useNavigate } from "react-router-dom";
// import { IoEyeOutline } from "react-icons/io5";
// import { MdOutlineModeEditOutline } from "react-icons/md";
// import toast from "react-hot-toast";
// import PaginationComponent from "../../../Components/PaginationComponent";
// import { RxCross2 } from "react-icons/rx";
// import dutyRosterService from "../../../Services/dutyrosterService";

// const TAB_TO_SHIFT = {
//   All: null,
//   Morning: "morning",
//   Evening: "evening",
//   Night: "night",
// };

// const Duty = () => {
//   const navigate = useNavigate();

//   const [activeTab, setActiveTab] = useState("All");
//   const tabs = ["All", "Morning", "Evening", "Night"];

//   const [viewMode, setViewMode] = useState("today"); // "today" | "all"

//   const [searchData, setSearchData] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [paginatedData, setPaginatedData] = useState([]);
//   const [duties, setDuties] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [selectedDuty, setSelectedDuty] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalLoading, setModalLoading] = useState(false);

//   const itemsPerPage = 10;
//   const [currentPage, setCurrentPage] = useState(1);

//   useEffect(() => {
//     const getDuties = async () => {
//       try {
//         setLoading(true);
//         if (viewMode === "today") {
//           const response = await dutyRosterService.fetchByDate();
//           const sorted = (response.duties || []).sort((a, b) => a.id - b.id);
//           setDuties(sorted);
//         } else {
//           const response = await dutyRosterService.fetchAll();
//           const sorted = (response.duties || []).sort((a, b) => a.id - b.id);
//           setDuties(sorted);
//         }
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error("Error fetching duties");
//       }
//     };
//     getDuties();
//   }, [viewMode]);

//   useEffect(() => {
//     const shift = TAB_TO_SHIFT[activeTab];

//     const filtered =
//       duties
//         ?.filter((item) => (shift ? item?.shift === shift : true))
//         ?.filter(
//           (item) =>
//             item?.full_name?.toLowerCase().includes(searchData.toLowerCase()) ||
//             item?.role_name?.toLowerCase().includes(searchData.toLowerCase())
//         ) || [];

//     setFilteredData(filtered);
//     setCurrentPage(1);
//   }, [searchData, duties, activeTab]);

//   const formatDate = (dateStr) => {
//     if (!dateStr) return "-";
//     return new Date(dateStr).toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     });
//   };

//   const formatTime = (t) => {
//     if (!t) return "";
//     const [h, m] = t.split(":");
//     const hour = parseInt(h, 10);
//     const ampm = hour >= 12 ? "PM" : "AM";
//     const displayHour = hour % 12 === 0 ? 12 : hour % 12;
//     return `${displayHour}:${m} ${ampm}`;
//   };

//   const handleView = async (duty) => {
//     setIsModalOpen(true);
//     setModalLoading(true);
//     setSelectedDuty(null);
//     try {
//       const response = await dutyRosterService.fetchById(duty.id);
//       setSelectedDuty(response.duty);
//     } catch (error) {
//       toast.error("Error fetching duty details");
//       setSelectedDuty(duty);
//     }
//     setModalLoading(false);
//   };

//   const handleClose = () => {
//     setIsModalOpen(false);
//     setSelectedDuty(null);
//   };

//   return (
//     <div className="p-3 sm:p-6">

//       {/* ───────── HEADER ───────── */}
//       <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 bg-white border border-gray-200 rounded-xl px-4 sm:px-6 py-4 mb-5 shadow-sm">

//         <div>
//           <h1 className="text-[15px] sm:text-[17px] font-[500] text-gray-800">
//             Duty Roster Table
//           </h1>
//           <p className="text-[11px] sm:text-[12px] text-gray-400 mt-0.5">
//             {filteredData?.length || 0} records found
//             {viewMode === "today" ? " for today" : ""}
//           </p>
//         </div>

//         <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">

//           {/* Today / All toggle */}
//           <div className="flex bg-gray-100 rounded-lg p-[3px] w-full sm:w-auto">
//             <button
//               onClick={() => setViewMode("today")}
//               className={`flex-1 sm:flex-none px-4 py-[6px] text-[12px] font-[500] rounded-md transition-colors ${
//                 viewMode === "today"
//                   ? "bg-white text-[#2F6DB4] shadow-sm"
//                   : "text-gray-500"
//               }`}
//             >
//               Today
//             </button>
//             <button
//               onClick={() => setViewMode("all")}
//               className={`flex-1 sm:flex-none px-4 py-[6px] text-[12px] font-[500] rounded-md transition-colors ${
//                 viewMode === "all"
//                   ? "bg-white text-[#2F6DB4] shadow-sm"
//                   : "text-gray-500"
//               }`}
//             >
//               All Dates
//             </button>
//           </div>

//           {/* Search */}
//           <div className="relative w-full sm:w-[230px]">
//             <SearchIcon
//               className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400"
//               style={{ fontSize: 16 }}
//             />
//             <input
//               type="search"
//               placeholder="Search duty..."
//               value={searchData}
//               onChange={(e) => setSearchData(e.target.value)}
//               className="pl-8 pr-3 py-[8px] w-full text-[13px] bg-gray-50 border border-gray-200 rounded-lg focus:outline-none"
//             />
//           </div>

//           {/* Button */}
//           <Link to="/duty-roster/add" className="w-full sm:w-auto">
//             <button className="w-full sm:w-auto bg-[#2F6DB4] hover:bg-[#255A8C] text-white text-[13px] px-4 py-[8px] rounded-lg">
//               + New Duty
//             </button>
//           </Link>

//         </div>
//       </div>

//       {/* ───────── TABS ───────── */}
//       <div className="bg-white rounded-xl shadow-sm border border-gray-200 w-fit mb-4">
//         <div className="flex border-b overflow-x-auto">
//           {tabs.map((tab) => (
//             <button
//               key={tab}
//               onClick={() => setActiveTab(tab)}
//               className={`px-6 py-3 whitespace-nowrap text-[13px] font-medium transition-all ${
//                 activeTab === tab
//                   ? "text-[#2F6DB4] border-b-2 border-[#2F6DB4]"
//                   : "text-gray-500 hover:text-[#2F6DB4]"
//               }`}
//             >
//               {tab}
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* ───────── DESKTOP TABLE ───────── */}
//       <div className="hidden md:block bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">

//         <div className="overflow-x-auto">
//           <table className="w-full min-w-[700px]">

//             <thead>
//               <tr className="bg-[#215187] text-[11px] uppercase text-white">
//                 <th className="py-3 px-4 text-left">Sr No.</th>
//                 <th className="py-3 px-4 text-left">Name</th>
//                 <th className="py-3 px-4 text-left">Role</th>
//                 <th className="py-3 px-4 text-left">Shift</th>
//                 <th className="py-3 px-4 text-left">Date</th>
//                 <th className="py-3 px-4 text-center">Action</th>
//               </tr>
//             </thead>

//             <tbody>
//               {loading ? (
//                 <tr>
//                   <td colSpan={6} className="py-10 text-center text-gray-400">
//                     Loading...
//                   </td>
//                 </tr>
//               ) : paginatedData?.length === 0 ? (
//                 <tr>
//                   <td colSpan={6} className="py-10 text-center text-gray-400">
//                     No records found
//                   </td>
//                 </tr>
//               ) : (
//                 paginatedData?.map((item, index) => (
//                   <tr
//                     key={item?.id}
//                     className="border-t hover:bg-gray-50 text-[13px]"
//                   >
//                     <td className="py-3 px-4">
//                       {(currentPage - 1) * itemsPerPage + index + 1}
//                     </td>
//                     <td className="py-3 px-4 font-[500]">{item?.full_name}</td>
//                     <td className="py-3 px-4">{item?.role_name}</td>
//                     <td className="py-3 px-4">
//                       <span className="capitalize">{item?.shift}</span>
//                       {(item?.start_time || item?.end_time) && (
//                         <div className="text-[11px] text-gray-400">
//                           {formatTime(item?.start_time)} - {formatTime(item?.end_time)}
//                         </div>
//                       )}
//                     </td>
//                     <td className="py-3 px-4">{formatDate(item?.duty_date)}</td>
//                     <td className="py-3 px-4 text-center">
//                       <div className="flex justify-center items-center gap-3">
//                         <button
//                           onClick={() => handleView(item)}
//                           className="bg-blue-50 text-blue-600 text-[12px] p-2 rounded-md hover:bg-blue-100 flex items-center gap-1"
//                         >
//                           <IoEyeOutline size={14} />
//                         </button>

//                         <button
//                           onClick={() => navigate(`/duty-roster/edit/${item.id}`)}
//                           className="text-gray-500 hover:text-[#2F6DB4]"
//                         >
//                           <MdOutlineModeEditOutline size={18} />
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>

//           </table>
//         </div>
//       </div>

//       {/* ───────── MOBILE CARDS ───────── */}
//       <div className="md:hidden flex flex-col gap-3">

//         {loading ? (
//           <div className="bg-white border rounded-xl py-10 text-center text-gray-400">
//             Loading...
//           </div>
//         ) : paginatedData?.length === 0 ? (
//           <div className="bg-white border rounded-xl py-10 text-center text-gray-400">
//             No records found
//           </div>
//         ) : (
//           paginatedData?.map((item, index) => (
//             <div
//               key={item?.id}
//               className="bg-white border rounded-xl p-4 shadow-sm"
//             >

//               <div className="flex justify-between items-start mb-3">
//                 <div>
//                   <p className="font-semibold text-gray-800">
//                     {item?.full_name}
//                   </p>
//                   <p className="text-[11px] text-gray-400">
//                     Sr No: {(currentPage - 1) * itemsPerPage + index + 1} &nbsp;•&nbsp; {item?.role_name}
//                   </p>
//                 </div>

//                 <div className="flex items-center gap-2">
//                   <button
//                     onClick={() => handleView(item)}
//                     className="bg-blue-50 text-blue-600 text-[12px] px-3 py-1 rounded-md flex items-center gap-1"
//                   >
//                     <IoEyeOutline size={14} />
//                   </button>

//                   <button
//                     onClick={() => navigate(`/duty-roster/edit/${item.id}`)}
//                     className="text-gray-500"
//                   >
//                     <MdOutlineModeEditOutline size={18} />
//                   </button>
//                 </div>
//               </div>

//               <p className="text-[12px] text-gray-600 capitalize">
//                 Shift: {item?.shift}
//                 {(item?.start_time || item?.end_time) && (
//                   <> ({formatTime(item?.start_time)} - {formatTime(item?.end_time)})</>
//                 )}
//                 &nbsp;•&nbsp; {formatDate(item?.duty_date)}
//               </p>

//             </div>
//           ))
//         )}

//       </div>

//       {/* ───────── PAGINATION ───────── */}
//       <PaginationComponent
//         filteredData={filteredData}
//         setPaginatedData={setPaginatedData}
//         currentPage={currentPage}
//         setCurrentPage={setCurrentPage}
//         itemsPerPage={10}
//       />

//       {/* ───────── MODAL ───────── */}
//       <Modal open={isModalOpen} sx={{ zIndex: 10000 }}>
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: { xs: "90%", sm: 420 },
//             bgcolor: "background.paper",
//             borderRadius: 3,
//             boxShadow: 24,
//             overflow: "hidden",
//           }}
//         >

//           {/* Header */}
//           <div className="bg-[#215187] px-5 py-4 flex justify-between items-center">
//             <Typography className="!text-white !text-[15px] !font-semibold">
//               Duty Details
//             </Typography>
//            <button
//               onClick={handleClose}
//               className="text-white text-[20px] bg-white/20 p-2 rounded-xl hover:bg-white/30 transition-all"
//             >
//           <RxCross2 size={16} />
//             </button>
//           </div>

//           {/* Body */}
//           {modalLoading ? (
//             <div className="p-8 text-center text-gray-400 text-[13px]">Loading...</div>
//           ) : selectedDuty ? (
//             <div className="p-5 flex flex-col gap-3 text-[13px]">

//               <div className="flex justify-between">
//                 <span className="text-gray-500">Duty ID</span>
//                 <span className="font-[500]">{selectedDuty.id}</span>
//               </div>

//               <div className="flex justify-between">
//                 <span className="text-gray-500">Staff Name</span>
//                 <span className="font-[500]">{selectedDuty.full_name}</span>
//               </div>

//               <div className="flex justify-between">
//                 <span className="text-gray-500">Role</span>
//                 <span className="font-[500]">{selectedDuty.role_name}</span>
//               </div>

//               <div className="flex justify-between">
//                 <span className="text-gray-500">Shift</span>
//                 <span className="font-[500] capitalize">{selectedDuty.shift}</span>
//               </div>

//               <div className="flex justify-between">
//                 <span className="text-gray-500">Time</span>
//                 <span className="font-[500]">
//                   {formatTime(selectedDuty.start_time)} - {formatTime(selectedDuty.end_time)}
//                 </span>
//               </div>

//               <div className="flex justify-between">
//                 <span className="text-gray-500">Duty Date</span>
//                 <span className="font-[500]">{formatDate(selectedDuty.duty_date)}</span>
//               </div>

//               <div className="flex justify-between">
//                 <span className="text-gray-500">Notes</span>
//                 <span className="text-right max-w-[60%]">
//                   {selectedDuty.notes || "-"}
//                 </span>
//               </div>

//               <button
//                 onClick={handleClose}
//                 className="mt-3 bg-[#2F6DB4] text-white py-2 rounded-lg text-[13px]"
//               >
//                 Close
//               </button>

//             </div>
//           ) : (
//             <div className="p-8 text-center text-gray-400 text-[13px]">No data found</div>
//           )}

//         </Box>
//       </Modal>

//     </div>
//   );
// };

// export default Duty;

import React, { useState, useEffect } from "react";
import { Modal, Box, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Link, useNavigate } from "react-router-dom";
import { IoEyeOutline } from "react-icons/io5";
import { MdOutlineModeEditOutline } from "react-icons/md";
import toast from "react-hot-toast";
import PaginationComponent from "../../../Components/PaginationComponent";
import { RxCross2 } from "react-icons/rx";
import dutyRosterService from "../../../Services/dutyrosterService";

const TAB_TO_SHIFT = {
  All: null,
  Morning: "morning",
  Evening: "evening",
  Night: "night",
};

// Doctor duties have role_id = NULL (LEFT JOIN roles), so role_name comes back
// null/undefined for them. This normalizes what we show for the "Role" column.
const getRoleLabel = (item) => {
  if (item?.doctor_id) {
    return item?.specialization
      ? `Doctor (${item.specialization})`
      : "Doctor";
  }
  return item?.role_name || "-";
};

const Duty = () => {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("All");
  const tabs = ["All", "Morning", "Evening", "Night"];

  const [viewMode, setViewMode] = useState("today"); 

  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const [duties, setDuties] = useState([]);
  const [loading, setLoading] = useState(false);

  const [selectedDuty, setSelectedDuty] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);

  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const getDuties = async () => {
      try {
        setLoading(true);
        if (viewMode === "today") {
          const response = await dutyRosterService.fetchByDate();
          const sorted = (response.duties || []).sort((a, b) => a.id - b.id);
          setDuties(sorted);
        } else {
          const response = await dutyRosterService.fetchAll();
          const sorted = (response.duties || []).sort((a, b) => a.id - b.id);
          setDuties(sorted);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching duties");
      }
    };
    getDuties();
  }, [viewMode]);

  useEffect(() => {
    const shift = TAB_TO_SHIFT[activeTab];

    const filtered =
      duties
        ?.filter((item) => (shift ? item?.shift === shift : true))
        ?.filter((item) => {
          const query = searchData.toLowerCase();
          const name = item?.full_name?.toLowerCase() || "";
          const role = getRoleLabel(item)?.toLowerCase() || "";
          return name.includes(query) || role.includes(query);
        }) || [];

    setFilteredData(filtered);
    setCurrentPage(1);
  }, [searchData, duties, activeTab]);

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    return new Date(dateStr).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const formatTime = (t) => {
    if (!t) return "";
    const [h, m] = t.split(":");
    const hour = parseInt(h, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    const displayHour = hour % 12 === 0 ? 12 : hour % 12;
    return `${displayHour}:${m} ${ampm}`;
  };

  const handleView = async (duty) => {
    setIsModalOpen(true);
    setModalLoading(true);
    setSelectedDuty(null);
    try {
      const response = await dutyRosterService.fetchById(duty.id);
      setSelectedDuty(response.duty);
    } catch (error) {
      toast.error("Error fetching duty details");
      setSelectedDuty(duty);
    }
    setModalLoading(false);
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setSelectedDuty(null);
  };

  return (
    <div className="p-3 sm:p-6">


      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 bg-white border border-gray-200 rounded-xl px-4 sm:px-6 py-4 mb-5 shadow-sm">

        <div>
          <h1 className="text-[15px] sm:text-[17px] font-[500] text-gray-800">
            Duty Roster Table
          </h1>
          <p className="text-[11px] sm:text-[12px] text-gray-400 mt-0.5">
            {filteredData?.length || 0} records found
            {viewMode === "today" ? " for today" : ""}
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">


          <div className="flex bg-gray-100 rounded-lg p-[3px] w-full sm:w-auto">
            <button
              onClick={() => setViewMode("today")}
              className={`flex-1 sm:flex-none px-4 py-[6px] text-[12px] font-[500] rounded-md transition-colors ${
                viewMode === "today"
                  ? "bg-white text-[#2F6DB4] shadow-sm"
                  : "text-gray-500"
              }`}
            >
              Today
            </button>
            <button
              onClick={() => setViewMode("all")}
              className={`flex-1 sm:flex-none px-4 py-[6px] text-[12px] font-[500] rounded-md transition-colors ${
                viewMode === "all"
                  ? "bg-white text-[#2F6DB4] shadow-sm"
                  : "text-gray-500"
              }`}
            >
              All Dates
            </button>
          </div>


          <div className="relative w-full sm:w-[230px]">
            <SearchIcon
              className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400"
              style={{ fontSize: 16 }}
            />
            <input
              type="search"
              placeholder="Search duty..."
              value={searchData}
              onChange={(e) => setSearchData(e.target.value)}
              className="pl-8 pr-3 py-[8px] w-full text-[13px] bg-gray-50 border border-gray-200 rounded-lg focus:outline-none"
            />
          </div>


          <Link to="/duty-roster/add" className="w-full sm:w-auto">
            <button className="w-full sm:w-auto bg-[#2F6DB4] hover:bg-[#255A8C] text-white text-[13px] px-4 py-[8px] rounded-lg">
              + New Duty
            </button>
          </Link>

        </div>
      </div>


      <div className="bg-white rounded-xl shadow-sm border border-gray-200 w-fit mb-4">
        <div className="flex border-b overflow-x-auto">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-6 py-3 whitespace-nowrap text-[13px] font-medium transition-all ${
                activeTab === tab
                  ? "text-[#2F6DB4] border-b-2 border-[#2F6DB4]"
                  : "text-gray-500 hover:text-[#2F6DB4]"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>


      <div className="hidden md:block bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">

        <div className="overflow-x-auto">
          <table className="w-full min-w-[800px]">

            <thead>
              <tr className="bg-[#215187] text-[11px] uppercase text-white">
                <th className="py-3 px-4 text-left">Sr No.</th>
                <th className="py-3 px-4 text-left">Name</th>
                <th className="py-3 px-4 text-left">Staff / Doctor ID</th>
                <th className="py-3 px-4 text-left">Role</th>
                <th className="py-3 px-4 text-left">Shift</th>
                <th className="py-3 px-4 text-left">Date</th>
                <th className="py-3 px-4 text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={7} className="py-10 text-center text-gray-400">
                    Loading...
                  </td>
                </tr>
              ) : paginatedData?.length === 0 ? (
                <tr>
                  <td colSpan={7} className="py-10 text-center text-gray-400">
                    No records found
                  </td>
                </tr>
              ) : (
                paginatedData?.map((item, index) => (
                  <tr
                    key={item?.id}
                    className="border-t hover:bg-gray-50 text-[13px]"
                  >
                    <td className="py-3 px-4">
                      {(currentPage - 1) * itemsPerPage + index + 1}
                    </td>
                    <td className="py-3 px-4 font-[500]">{item?.full_name}</td>
                    <td className="py-3 px-4">{item?.doctor_id || item?.staff_id || "-"}</td>
                    <td className="py-3 px-4">{getRoleLabel(item)}</td>
                    <td className="py-3 px-4">
                      <span className="capitalize">{item?.shift}</span>
                      {(item?.start_time || item?.end_time) && (
                        <div className="text-[11px] text-gray-400">
                          {formatTime(item?.start_time)} - {formatTime(item?.end_time)}
                        </div>
                      )}
                    </td>
                    <td className="py-3 px-4">{formatDate(item?.duty_date)}</td>
                    <td className="py-3 px-4 text-center">
                      <div className="flex justify-center items-center gap-3">
                        <button
                          onClick={() => handleView(item)}
                          className="bg-blue-50 text-blue-600 text-[12px] p-2 rounded-md hover:bg-blue-100 flex items-center gap-1"
                        >
                          <IoEyeOutline size={14} />
                        </button>

                        <button
                          onClick={() => navigate(`/duty-roster/edit/${item.id}`)}
                          className="text-gray-500 hover:text-[#2F6DB4]"
                        >
                          <MdOutlineModeEditOutline size={18} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>

          </table>
        </div>
      </div>


      <div className="md:hidden flex flex-col gap-3">

        {loading ? (
          <div className="bg-white border rounded-xl py-10 text-center text-gray-400">
            Loading...
          </div>
        ) : paginatedData?.length === 0 ? (
          <div className="bg-white border rounded-xl py-10 text-center text-gray-400">
            No records found
          </div>
        ) : (
          paginatedData?.map((item, index) => (
            <div
              key={item?.id}
              className="bg-white border rounded-xl p-4 shadow-sm"
            >

              <div className="flex justify-between items-start mb-3">
                <div>
                  <p className="font-semibold text-gray-800">
                    {item?.full_name}
                  </p>
                  <p className="text-[11px] text-gray-400">
                    {item?.doctor_id ? "Doctor ID" : "Staff ID"}: {item?.doctor_id || item?.staff_id || "-"}
                  </p>
                  <p className="text-[11px] text-gray-400">
                    Sr No: {(currentPage - 1) * itemsPerPage + index + 1} &nbsp;•&nbsp; {getRoleLabel(item)}
                  </p>
                </div>

                <div className="flex items-center gap-2">
                  <button
                    onClick={() => handleView(item)}
                    className="bg-blue-50 text-blue-600 text-[12px] px-3 py-1 rounded-md flex items-center gap-1"
                  >
                    <IoEyeOutline size={14} />
                  </button>

                  <button
                    onClick={() => navigate(`/duty-roster/edit/${item.id}`)}
                    className="text-gray-500"
                  >
                    <MdOutlineModeEditOutline size={18} />
                  </button>
                </div>
              </div>

              <p className="text-[12px] text-gray-600 capitalize">
                Shift: {item?.shift}
                {(item?.start_time || item?.end_time) && (
                  <> ({formatTime(item?.start_time)} - {formatTime(item?.end_time)})</>
                )}
                &nbsp;•&nbsp; {formatDate(item?.duty_date)}
              </p>

            </div>
          ))
        )}

      </div>


      <PaginationComponent
        filteredData={filteredData}
        setPaginatedData={setPaginatedData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        itemsPerPage={10}
      />


      <Modal open={isModalOpen} sx={{ zIndex: 10000 }}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", sm: 420 },
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: 24,
            overflow: "hidden",
          }}
        >


          <div className="bg-[#215187] px-5 py-4 flex justify-between items-center">
            <Typography className="!text-white !text-[15px] !font-semibold">
              Duty Details
            </Typography>
           <button
              onClick={handleClose}
              className="text-white text-[20px] bg-white/20 p-2 rounded-xl hover:bg-white/30 transition-all"
            >
          <RxCross2 size={16} />
            </button>
          </div>


          {modalLoading ? (
            <div className="p-8 text-center text-gray-400 text-[13px]">Loading...</div>
          ) : selectedDuty ? (
            <div className="p-5 flex flex-col gap-3 text-[13px]">

              <div className="flex justify-between">
                <span className="text-gray-500">Duty ID</span>
                <span className="font-[500]">{selectedDuty.id}</span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-500">
                  {selectedDuty.doctor_id ? "Doctor Name" : "Staff Name"}
                </span>
                <span className="font-[500]">{selectedDuty.full_name}</span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-500">Role</span>
                <span className="font-[500]">{getRoleLabel(selectedDuty)}</span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-500">Shift</span>
                <span className="font-[500] capitalize">{selectedDuty.shift}</span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-500">Time</span>
                <span className="font-[500]">
                  {formatTime(selectedDuty.start_time)} - {formatTime(selectedDuty.end_time)}
                </span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-500">Duty Date</span>
                <span className="font-[500]">{formatDate(selectedDuty.duty_date)}</span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-500">Notes</span>
                <span className="text-right max-w-[60%]">
                  {selectedDuty.notes || "-"}
                </span>
              </div>

              <button
                onClick={handleClose}
                className="mt-3 bg-[#2F6DB4] text-white py-2 rounded-lg text-[13px]"
              >
                Close
              </button>

            </div>
          ) : (
            <div className="p-8 text-center text-gray-400 text-[13px]">No data found</div>
          )}

        </Box>
      </Modal>

    </div>
  );
};

export default Duty;
